import $ from "jquery";
import { useEffect } from "react";

export const useAccordion = (englishFaqs?: any, nepaliFaqs?: any) => {
  useEffect(() => {
    const $accordions = $(".td_accordian");
    $accordions.children(".td_accordian_body").hide();
    const $groups = $(".td_accordians");

    $groups.each(function () {
      const $first = $(this).find(".td_accordian").first();

      $first.addClass("active");
      $first.children(".td_accordian_body").show();
    });
    $(".td_accordian_head")
      .off("click")
      .on("click", function () {
        const $parent = $(this).parent(".td_accordian");
        $parent
          .siblings(".td_accordian")
          .removeClass("active")
          .children(".td_accordian_body")
          .slideUp(250);
        $parent.addClass("active");
        $parent.children(".td_accordian_body").slideDown(250);
      });

    return () => {
      $(".td_accordian_head").off("click");
    };
  }, [englishFaqs, nepaliFaqs]);
};